import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const CloseIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "close",
  "CloseIcon",
  ["currentColor"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M7.99994 8.94281L11.5354 12.4782L12.4782 11.5354L8.94275 8L12.4782 4.46452L11.5354 3.52171L7.99994 7.05719L4.46429 3.52155L3.52148 4.46435L7.05713 8L3.52155 11.5356L4.46436 12.4784L7.99994 8.94281Z" fill={colorList[0]} fillOpacity="0.9"/></g></svg>
);

export default CloseIcon;
